import styled from 'styled-components'

export const Wrapper = styled.div`
    padding: 50px 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    @media ${(props) => props.theme.query.min.tablet} {
        flex-direction: row;
        padding-top: 50px;
        padding-bottom: 100px;
        padding-left: 0;
        padding-right: 0;
    }
`

export const List = styled.div`
    max-width: 800px;
    width: 100%;
`

export const SideWrapper = styled.div`
    width: 100%;

    @media ${(props) => props.theme.query.min.tablet} {
        max-width: 270px;
        margin-left: 30px;
    }
`

export const CategoryWrapper = styled.div`
    ${(props) => props.theme.typo.displayM}
    color: ${(props) => props.theme.color.g500};
    ${(props) => props.theme.fontWeight.bold};
    padding-left: 20px;
    padding-right: 20px;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayL}
        padding-left: 0;
        padding-right: 0;
    }
`
